module.exports = __webpack_public_path__ + "img/JalaPro.f297c78b.svg";